import React from 'react';
import { ShoppingBag, Gift, Star } from '@phosphor-icons/react';
import { motion } from 'framer-motion';

const MerchGallery = () => {
  const merchItems = [
    {
      id: 'starter-kit',
      name: 'Federation Starter Kit',
      tokens: 0,
      isFree: true,
      description: 'Your gateway to the NextXus ecosystem. Includes digital welcome pack and onboarding materials.',
      image: 'https://images.unsplash.com/photo-1698376621004-70ce754157d1'
    },
    {
      id: 'echo-tee',
      name: 'Echo v2.1 T-Shirt',
      tokens: 15,
      description: 'Premium black tee with neon cyan Echo branding. 100% organic cotton.',
      image: 'https://images.unsplash.com/photo-1521572163474-6864f9cf17ab'
    },
    {
      id: 'federation-hoodie',
      name: 'Federation Hoodie',
      tokens: 30,
      description: 'Limited edition heavyweight hoodie with embroidered NextXus logo.',
      image: 'https://images.unsplash.com/photo-1556821840-3a63f95609a7'
    },
    {
      id: 'federation-pin',
      name: 'Federation Pin Set',
      tokens: 8,
      description: 'Collectible enamel pin set featuring NextXus iconography.',
      image: 'https://images.unsplash.com/photo-1610652492954-a04609e9c050'
    },
    {
      id: 'neural-poster',
      name: 'Neural Network Poster',
      tokens: 12,
      description: '24x36" high-quality print of the iconic Echo neural visualization.',
      image: 'https://images.pexels.com/photos/14314636/pexels-photo-14314636.jpeg'
    },
    {
      id: 'crypto-cap',
      name: 'Crypto Currency Cap',
      tokens: 10,
      description: 'Adjustable snapback with NextXus embroidery. One size fits all.',
      image: 'https://images.unsplash.com/photo-1588850561407-ed78c282e89b'
    }
  ];

  return (
    <div className="min-h-screen py-16" data-testid="merch-gallery-page">
      <div className="max-w-7xl mx-auto px-6">
        {/* Header */}
        <div className="text-center mb-16">
          <ShoppingBag size={64} weight="duotone" className="neon-cyan mx-auto mb-6" />
          <h1 className="text-4xl md:text-5xl font-black mb-4 tracking-tighter">Merch Gallery</h1>
          <p className="text-xl text-gray-400">Redeem your tokens for exclusive NextXus gear</p>
        </div>

        {/* Featured FREE Item */}
        <motion.div
          initial={{ opacity: 0, scale: 0.95 }}
          animate={{ opacity: 1, scale: 1 }}
          className="mb-16 p-8 glass-surface border-2 border-[#00FFA3] rounded-sm relative overflow-hidden"
          data-testid="featured-free-item"
        >
          <div className="absolute top-4 right-4">
            <div className="flex items-center gap-2 bg-[#00FFA3] text-[#030305] px-4 py-2 rounded-sm font-bold">
              <Gift size={20} weight="fill" />
              FREE
            </div>
          </div>
          <div className="grid md:grid-cols-2 gap-8 items-center">
            <img
              src={merchItems[0].image}
              alt={merchItems[0].name}
              className="w-full h-64 object-cover rounded"
            />
            <div>
              <h2 className="text-3xl font-bold mb-4 neon-green">{merchItems[0].name}</h2>
              <p className="text-gray-300 mb-6">{merchItems[0].description}</p>
              <div className="flex items-center gap-3 mb-6">
                <Star size={24} weight="fill" className="text-[#FFB800]" />
                <span className="text-2xl font-bold mono">0 Tokens</span>
              </div>
              <button
                className="px-8 py-3 bg-[#00FFA3] text-[#030305] font-bold rounded-sm hover:bg-[#00E892] transition-colors"
                data-testid="claim-starter-kit-btn"
              >
                Claim Your Kit
              </button>
            </div>
          </div>
        </motion.div>

        {/* Merch Grid */}
        <div className="grid md:grid-cols-3 gap-8">
          {merchItems.slice(1).map((item, idx) => (
            <motion.div
              key={item.id}
              initial={{ opacity: 0, y: 20 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ delay: idx * 0.1 }}
              className="group cursor-pointer"
              data-testid={`merch-item-${item.id}`}
            >
              <div className="relative overflow-hidden rounded-sm mb-4">
                <img
                  src={item.image}
                  alt={item.name}
                  className="w-full h-64 object-cover transition-transform duration-500 group-hover:scale-110"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-black/80 to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-300 flex items-end p-6">
                  <button className="w-full py-2 bg-[#00F0FF] text-[#030305] font-bold rounded-sm" data-testid={`redeem-${item.id}-btn`}>
                    Redeem
                  </button>
                </div>
              </div>
              <h3 className="text-xl font-bold mb-2">{item.name}</h3>
              <p className="text-sm text-gray-400 mb-3">{item.description}</p>
              <div className="flex items-center gap-2">
                <span className="mono font-bold text-[#00F0FF]">{item.tokens} Tokens</span>
              </div>
            </motion.div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default MerchGallery;